import { Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { FeatureFlagService } from './feature-flag.service';

export function injectFeatureFlag(featureName: string, defaultValue?: boolean): Signal<boolean> {
  const appFeatures = inject(FeatureFlagService);
  return toSignal(appFeatures.getFlagValue(featureName, defaultValue));
}
